(function(){
  function init(){
    var ci=document.getElementById('ndz-ci')||document.querySelector('[id^="nd-lv-input-"]');
    var cb=document.getElementById('ndz-cb')||document.querySelector('[id^="nd-lv-button-"]');
    var cr=document.getElementById('ndz-cr')||document.querySelector('[id^="nd-lv-result-"]');
    if(!ci||!cb||!cr)return;

    var FC={
      "A0":["France"],"A1":["France"],"A2":["France"],"AA":["France"],"AH":["France"],"AN":["France"],"AR":["France"],"AS":["France"],"BA":["France"],"BJ":["France"],"BU":["France"],"CO":["France"],"CT":["France"],"DR":["France"],"DU":["France"],"ET":["France"],"MB":["France"],"MI":["France"],"NO":["France"],"RA":["France"],"RI":["France"],"SL":["France"],"SN":["France"],"SP":["France"],"SR":["France"],"TJ":["France"],"TH":["France"],"TR":["France"],"VI":["France"],"VX":["France"],
      "CA":["Spain"],"GI":["Spain"],"LB":["Spain"],"LO":["Spain"],"UB":["Spain"],
      "LP":["Germany"],"OL":["Germany"],
      "BC":["Italy","Spain"],"BO":["Italy"],"CE":["Italy"],"FO":["Italy"],"MA":["Italy"],"NZ":["Italy"],"OB":["Italy"],"PL":["Italy"],"RC":["Italy"],"RE":["Italy"],"SA":["Italy","France"],"TD":["Italy"],
      "DI":["Switzerland"],"FA":["Switzerland"],
      "FC":["USA"],"FH":["USA"],"OS":["USA"],"TX":["USA"],
      "FL":["France","USA"],"LA":["France","USA"],"SD":["France","USA"],
      "LW":["France","Spain"],"LM":["France","Spain"]
    };

    function clean(v){return v.toUpperCase().replace(/[^A-Z0-9]/g,'');}

    function ft(p){
      if(!FC[p])return{v:'Not in our current reference list',n:'The factory prefix may be uncommon, historical, or missing from our reference database. This alone is not a determination of authenticity.'};
      var c=FC[p];
      if(c.length===1)return{v:c[0],n:'Use the physical \u201cMade in\u201d stamp on the item as the final country reference.'};
      return{v:c.join(' / '),n:'This prefix has been associated with more than one country. Check the physical \u201cMade in\u201d stamp on the item.'};
    }

    function isoW(y){var d=new Date(Date.UTC(y,11,28));var day=d.getUTCDay()||7;d.setUTCDate(d.getUTCDate()+4-day);var ys=new Date(Date.UTC(d.getUTCFullYear(),0,1));return Math.ceil((((d-ys)/86400000)+1)/7);}

    function show(html,err){
      cr.innerHTML=html;
      cr.classList.add('is-visible');
      cr.scrollIntoView({behavior:'smooth',block:'nearest'});
      if(err){cr.classList.add('ndr-error');cr.classList.add('nd-error');}
      else{cr.classList.remove('ndr-error');cr.classList.remove('nd-error');}
    }

    function grid(items){
      return '<div class="ndr-grid nd-grid">'+items.map(function(i){
        return '<div class="ndr-item nd-item"><span class="ndr-label nd-label">'+i[0]+'</span><span class="ndr-value nd-value">'+i[1]+'</span></div>';
      }).join('')+'</div>';
    }

    function note(txt){return '<div class="ndr-note nd-message">'+txt+'</div>';}
    function err(txt){return '<div class="ndr-error-msg nd-message nd-error">'+txt+'</div>';}

    function check(){
      var code=clean(ci.value);
      if(!code){show(err('<strong>Enter a date code.</strong><br>Please enter the characters exactly as they appear inside the item.'),true);return;}

      // 1980s: 2 letters + 4 digits where digits 1-2 are 80-89 and digits 3-4 are a valid month
      if(/^[A-Z]{2}[0-9]{4}$/.test(code)){
        var px=code.slice(0,2),dg=code.slice(2);
        var oldYY=Number(dg.slice(0,2)),oldMM=Number(dg.slice(2,4));
        if(oldYY>=80&&oldYY<=89&&oldMM>=1&&oldMM<=12){
          var yr80=1900+oldYY;
          var mn80=new Date(yr80,oldMM-1,1).toLocaleString('en-US',{month:'long'});
          var f80=ft(px);
          show('<div class="ndr-code nd-code">'+code+'</div>'+grid([['Likely Production',mn80+' '+yr80],['Format','Late 1980s month / year'],['Factory Prefix',px],['Associated Location',f80.v]])+note('<strong>Historical-format notice:</strong> This code follows a documented late-1980s Louis Vuitton format. Treat this as a historical reference clue rather than a definitive production determination.<br><br>'+f80.n));
          return;
        }

        // Standard 1990-2021 decoder
        var wk=Number(dg[0]+dg[2]),yy=Number(dg[1]+dg[3]);
        var f=ft(px);
        if(yy>=90||yy<=6){
          if(wk>=1&&wk<=12){
            var fy=yy<=6?2000+yy:1900+yy;
            var mn=new Date(fy,wk-1,1).toLocaleString('en-US',{month:'long'});
            show('<div class="ndr-code nd-code">'+code+'</div>'+grid([['Production',mn+' '+fy],['Format','1990\u20132006 month / year'],['Factory Prefix',px],['Associated Location',f.v]])+note(f.n));
            return;
          }
        }
        if(yy>=7&&yy<=21){
          var fy2=2000+yy,mw=isoW(fy2);
          if(wk>=1&&wk<=mw){
            show('<div class="ndr-code nd-code">'+code+'</div>'+grid([['Production','Week '+String(wk).padStart(2,'0')+' of '+fy2],['Format','2007\u2013early 2021 week / year'],['Factory Prefix',px],['Associated Location',f.v]])+note(f.n));
            return;
          }
          show('<div class="ndr-code nd-code">'+code+'</div>'+err('<strong>Something doesn\'t match.</strong><br>The numerical portion would indicate week '+wk+' of '+fy2+', which is outside the valid ISO-week range for that year. A worn or misread character can affect the result.'),true);
          return;
        }
        if(yy>=22){
          show('<div class="ndr-code nd-code">'+code+'</div>'+err('<strong>The date does not fit the standard visible-code timeline.</strong><br>The decoded year would be '+(2000+yy)+', which falls after Louis Vuitton\'s transition away from traditional visible date codes around 2021. This is not, by itself, an authentication determination.'),true);
          return;
        }
        show(err('<strong>We couldn\'t confidently decode that code.</strong><br>Check that all characters were entered correctly.'),true);
        return;
      }

      // 1980s: pure numeric or letters+digits in other arrangements (e.g. 836, TH863, 863TH)
      var lets=code.replace(/[0-9]/g,''),nums=code.replace(/[A-Z]/g,'');
      if((lets.length===0||lets.length===2)&&(nums.length===3||nums.length===4)){
        var yy2=Number(nums.slice(0,2)),mo=Number(nums.slice(2)),yr=null;
        yr=(yy2>=80&&yy2<=89)?1900+yy2:null;
        if(yr&&mo>=1&&mo<=12){
          var mn2=new Date(yr,mo-1,1).toLocaleString('en-US',{month:'long'}),f2=lets?ft(lets):null;
          var gitems=[['Likely Production',mn2+' '+yr],['Era','1980s historical format']];
          if(lets&&f2)gitems.push(['Factory Prefix',lets],['Associated Location',f2.v]);
          show('<div class="ndr-code nd-code">'+code+'</div>'+grid(gitems)+note('<strong>Historical-format notice:</strong> Early Louis Vuitton date-code systems were less standardized. Treat this as a historical reference clue rather than a definitive production determination.'+(lets&&f2?'<br><br>'+f2.n:'')));
          return;
        }
      }

      show(err('<strong>We couldn\'t confidently decode that code.</strong><br>Check that all characters were entered correctly. Standard later codes contain two letters followed by four numbers.'),true);
    }

    cb.addEventListener('click',check);
    ci.addEventListener('keydown',function(e){if(e.key==='Enter')check();});
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
